export default __webpack_public_path__ + "static/media/emailPhoneChange.462a7057.svg";